// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/financial-institution-img/financial_institutionbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/financial-institution-img/financial_institutionbg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/financial-institution-img/market_sectionbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/financial-institution-img/market_sectionbg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/images/financial-institution-img/back_img_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../public/images/financial-institution-img/trade_exchange_cta.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   FINANCIAL INSTITUTION PAGE STYLES
   ========================================================================== */

.fin-inst-page-wrapper {
  background-color: #171a20;
  color: #f1f5f9;
  position: relative;
  min-height: 100vh;
  font-family: inherit;
}

body.light_theme .fin-inst-page-wrapper {
  background-color: #fff;
  color: #0f172a;
}

/* Light / Dark Image Switching */
.fin-inst-page-wrapper img.light_img {
  display: block;
}

.fin-inst-page-wrapper img.dark_img {
  display: none;
}

body.light_theme .fin-inst-page-wrapper img.light_img {
  display: none !important;
}

body.light_theme .fin-inst-page-wrapper img.dark_img {
  display: block !important;
}

.fin-inst-container {
  max-width: 1480px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.fin-inst-text-gold {
  color: #D1AA67;
}

.fin-inst-features-section p.subtext {
  font-size: 24px;
  color: #9CA3AF;
  padding-top: 18px;
}

/* ==========================================================================
   1. HERO SECTION
   ========================================================================== */

.herovector {
  width: 58px;
}

.fin-inst-hero-section {
  position: relative;
  min-height: 1018px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  padding: 0px 0 0px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
}

body.light_theme .fin-inst-hero-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* Ambient Floating Background Vectors */
.fin-inst-hero-decor-1 {
  position: absolute;
  top: 19%;
  left: 17%;
  opacity: 1;
  pointer-events: none;
  animation: finFloatSlow 7s ease-in-out infinite alternate;
}

.fin-inst-hero-decor-2 {
  position: absolute;
  top: 34%;
  right: 15%;
  /* opacity: 0.6; */
  pointer-events: none;
  animation: finFloatSlow 8s ease-in-out infinite alternate-reverse;
}

.fin-inst-hero-decor-3 {
  position: absolute;
  bottom: 19%;
  left: 25%;
  /* opacity: 0.5; */
  pointer-events: none;
  animation: finFloatSlow 6s ease-in-out infinite alternate;
}

.fin-inst-hero-decor-4 {
  position: absolute;
  bottom: 22%;
  right: 28%;
  /* opacity: 0.5; */
  pointer-events: none;
  animation: finFloatSlow 9s ease-in-out infinite alternate-reverse;
}

@keyframes finFloatSlow {
  0% {
    transform: translateY(0px) rotate(0deg);
  }

  100% {
    transform: translateY(-15px) rotate(3deg);
  }
}

.ctaouterbl {
  max-width: 720px;
  margin: 0 auto;
}

.fin-inst-hero-content {
  position: relative;
  z-index: 3;
  max-width: 1080px;
  margin: 0 auto;
}

.fin-inst-hero-badge {
  display: inline-block;
  padding: 10px 24px;
  border-radius: 9999px;
  background: #24262B;
  border: 1px solid rgb(80 80 80 / 35%);
  margin-bottom: 18px;
}

.fin-inst-hero-badge span {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  background: linear-gradient(91deg, #949494, #ffffff, #949494);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

.fin-inst-hero-title {
  font-size: 80px;
  font-weight: 700;
  line-height: 1.16;
  margin-bottom: 24px;
  background: linear-gradient(91deg, #949494, #ffffff, #949494);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

body.light_theme .fin-inst-hero-title {
  background: linear-gradient(91deg, #949494, #000000, #949494);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

.fin-inst-hero-subtitle {
  font-size: 24px;
  line-height: 1.6;
  color: #9CA3AF;
  max-width: 970px;
  margin: 0 auto 40px;
  font-weight: 400;
}

body.light_theme .fin-inst-hero-subtitle {
  color: #475569;
}

.fin-inst-hero-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
}

.fin-inst-hero-actions a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
  padding: 15px 36px;
  min-height: 56px;
  cursor: pointer;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  border-radius: 9999px;
}

body.light_theme .fin-inst-hero-badge {
  background: rgb(153 153 153 / 10%);
  border: 1px solid rgb(80 80 80 / 10%);
}

body.light_theme .fin-inst-hero-badge span {
  background: linear-gradient(91deg, #949494, #000000, #949494);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

/* Primary and Secondary Buttons */
.fin-inst-btn-primary {
  background: #D1AA67;
  color: #0b0e14;
  text-decoration: none;
  border: none;
  box-shadow: inset 0px 0px 0px 4px rgb(214 183 130);
}

.fin-inst-btn-primary:hover {
  background: #deb776;
  color: #000;
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(209, 170, 103, 0.5);
}

.fin-inst-btn-secondary {
  background: #414141;
  color: #e2e8f0;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.12);

}

body.light_theme .fin-inst-btn-secondary {
  background: #414141;
  color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.fin-inst-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
  border-color: rgba(209, 170, 103, 0.4);
  transform: translateY(-2px);
}

body.light_theme .fin-inst-btn-secondary:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #0f172a;
}

body.light_theme .fin-inst-features-section::before {
  background: #ffffff;
}

/* Section Header Utility */
.fin-inst-section-header {
  text-align: center;
  margin-bottom: 60px;
}

.fin-inst-section-title {
  font-size: 60px;
  font-weight: 600;
  line-height: 1.10;
  color: #ffffff;
  margin: 0;
}

body.light_theme .fin-inst-section-title {
  color: #0f172a;
}

/* ==========================================================================
   2. EVERYTHING AN EXCHANGE SHOULD BE (10 FEATURES GRID)
   ========================================================================== */
.fin-inst-features-section {
  position: relative;
  padding: 100px 0 110px;
}

body.light_theme .fin-inst-features-section {
  background-color: #ffffff;
  background-image: none;
}

.fin-inst-features-section::before {
  position: absolute;
  content: "";
  width: 50%;
  height: 300px;
  background: #6C604C;
  top: 50px;
  filter: blur(100px);
  left: 24%;
  border-radius: 100%;
  z-index: 0;
}

.fin-inst-features-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 60px;
}

body.light_theme .fin-inst-feature-icon-box {
  background: linear-gradient(140deg, #ECDDC3 0%, #EEEBE7);
  border: 1px solid rgb(54 51 47 / 16%);
}

body.light_theme .fin-inst-feature-icon-box img {
  filter: invert(1);
}

.fin-inst-feature-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.35s ease;
  position: relative;
}

.fin-inst-feature-after {
  position: absolute;
  top: 43px;
  left: 64px;
  z-index: 333;
}


.fin-inst-feature-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  position: relative;
  z-index: 999;
}

.fin-inst-feature-icon-box {
  width: 88px;
  height: 88px;
  min-width: 88px;
  border-radius: 50px;
  background: linear-gradient(140deg, rgb(111 95 69) 0%, rgb(19 18 17) 100%);
  border: 1px solid rgb(54 51 47);
  display: flex;
  align-items: center;
  justify-content: center;
}

.fin-inst-feature-icon {
  width: 42px;
  object-fit: contain;
}

.fin-inst-feature-num {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(180deg, #b08d53 0%, rgb(0 0 0 / 0%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

.fin-inst-feature-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 10px;
  line-height: 1.35;
}

body.light_theme .fin-inst-feature-title {
  color: #0f172a;
}

.fin-inst-feature-desc {
  font-size: 14px;
  line-height: 1.55;
  color: #95959D;
  margin: 0;
}

body.light_theme .fin-inst-feature-desc {
  color: #64748b;
}

/* ==========================================================================
   3. THE MOST IMPORTANT FEATURE (MPC & CUSTODY)
   ========================================================================== */
.fin-inst-custody-section {
  position: relative;
  padding: 110px 0;
  background-color: #0b0e14;
  overflow: hidden;
}

.fin-inst-custody-section::before {
  position: absolute;
  content: "";
  width: 300px;
  height: 300px;
  background: #6C604C;
  opacity: 0.9;
  top: 0px;
  filter: blur(90px);
  left: 0%;
  border-radius: 100%;
  z-index: 0;
}

body.light_theme .fin-inst-custody-section {
  background-color: #ffffff;
}

body.light_theme .fin-inst-custody-section::before {
  background: rgb(209 170 103 / 60%);
  left: -50px;
}

.fin-inst-custody-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 60px;
  align-items: center;
}

.fin-inst-custody-title {
  font-size: 60px;
  font-weight: 600;
  line-height: 1.22;
  color: #ffffff;
  margin-bottom: 20px;
}

body.light_theme .fin-inst-custody-title {
  color: #0f172a;
}

.fin-inst-custody-desc {
  font-size: 24px;
  line-height: 1.7;
  color: #9CA3AF;
  margin-bottom: 18px;
}

body.light_theme .fin-inst-custody-desc {
  color: #475569;
}

.fin-inst-custody-img-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fin-inst-custody-img {
  width: 100%;
  max-width: 520px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 16px 36px rgba(0, 0, 0, 0.4));
}

/* ==========================================================================
   4. NEW TO CRYPTO. NOT TO MARKETS.
   ========================================================================== */
.fin-inst-markets-section {
  position: relative;
  padding: 100px 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

body.light_theme .fin-inst-markets-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.fin-inst-markets-grid {
  display: grid;
  grid-template-columns: 0.85fr 1.15fr;
  gap: 32px;
  align-items: center;
}

.fin-inst-markets-img-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.fin-inst-markets-img {
  width: 100%;
  max-width: 520px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 16px 36px rgba(0, 0, 0, 0.5));
}

.fin-inst-markets-title {
  font-size: 60px;
  font-weight: 600;
  line-height: 1.1;
  color: #ffffff;
  margin-bottom: 18px;
}

body.light_theme .fin-inst-markets-title {
  color: #0f172a;
}

.fin-inst-markets-desc {
  font-size: 24px;
  line-height: 1.5;
  color: #9CA3AF;
  margin-bottom: 18px;
}

body.light_theme .fin-inst-markets-desc {
  color: #475569;
}

.fin-inst-markets-stats-strip {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 0px;
  padding-top: 6px;
}

.fin-inst-market-stat-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-right: 1px solid rgb(209 170 103 / 12%);
  padding-right: 16px;
}

.fin-inst-stat-icon-box {
  width: 45px;
  height: 45px;
  min-width: 45px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.09);
  border: 1px solid rgb(209 170 103 / 12%);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}

.fin-inst-market-stat-item:last-child {
  border: none;
  padding-right: 0px;
}

body.light_theme .fin-inst-stat-icon-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.fin-inst-stat-icon {
  width: 24px;
  /* height: 32px; */
  object-fit: contain;
}

.fin-inst-stat-content {
  display: flex;
  flex-direction: column;
}

.fin-inst-stat-title {
  font-size: 17px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 3px;
  line-height: 1.25;
}

body.light_theme .fin-inst-stat-title {
  color: #0f172a;
}

.fin-inst-stat-sub {
  font-size: 12px;
  color: #9CA3AF;
  margin: 0;
  line-height: 1.4;
}

body.light_theme .fin-inst-stat-sub {
  color: #64748b;
}

/* ==========================================================================
   5. ONE REGULATED VENUE FOR EVERYTHING (SCROLL-DRIVEN STORYTELLING)
   ========================================================================== */
.crypto-story {
  position: relative;
  padding: 130px 0 120px;
  background-color: #171A20;
  overflow: hidden;
}

.crypto-story::before {
  position: absolute;
  content: "";
  width: 55%;
  height: 90px;
  background: rgb(209 170 103 / 70%);
  top: -60px;
  left: 24%;
  filter: blur(100px);
  border-radius: 50%;
  z-index: 0;
}

body.light_theme .crypto-story {
  background-color: #fff;
}

.crypto-story-heading {
  text-align: center;
  margin-bottom: 0px;
}

.crypto-story-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  column-gap: 80px;
  align-items: stretch;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

.crypto-story-content {
  position: relative;
  min-width: 0;
}

.story-item {
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 0;
  transition: opacity 0.4s ease, transform 0.4s ease;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.story-item.is-active {
  opacity: 1;
  transform: translateY(0);
}

.story-item.is-inactive {
  opacity: 0.25;
  transform: translateY(0);
}

.story-item:hover {
  opacity: 0.7;
}

.story-item.is-active:hover {
  opacity: 1;
}

.story-num {
  font-size: 92px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -2px;
  background: linear-gradient(180deg, #ffffff 0%, #0f0f0f 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  display: inline-block;
  margin-bottom: 10px;
}

body.light_theme .story-num {
  background: linear-gradient(180deg, rgb(153 153 153 / 40%) 0%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.story-title {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

body.light_theme .story-title {
  color: #0f172a;
}

.story-desc {
  font-size: 20px;
  line-height: 1.6;
  color: #7b7b7b;
  margin: 0;
  max-width: 480px;
}

body.light_theme .story-desc {
  color: #475569;
}

.story-card-mobile-visual {
  display: none;
}

.crypto-story-visual-column {
  position: relative;
  height: 100%;
  min-width: 0;
}

.crypto-story-sticky {
  position: sticky;
  top: 100px;
  height: calc(100vh - 160px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.crypto-story-image {
  position: relative;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 20px 0px 0px;
  border-radius: 36px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.12);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .crypto-story-image {
  box-shadow: 0 20px 50px rgb(0 0 0 / 7%);
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #ffffff;
}

.story-img-active {
  max-width: 560px;
  height: 440px;
  object-fit: contain;
  display: block;
  opacity: 1;
  animation: storyImageFade 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  will-change: opacity, transform;
}

@keyframes storyImageFade {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.crypto-story-image.crypto-story-image-5 {
  justify-content: end;
}

.crypto-story-image.crypto-story-image-1 {
  justify-content: end;
}

/* ==========================================================================
   6. BUILT FOR HOW YOU USE CRYPTO (3 CARDS)
   ========================================================================== */
.fin-inst-usecases-section {
  position: relative;
  padding: 110px 0;
  overflow: hidden;
}

.fin-inst-usecases-section::before {
  position: absolute;
  content: "";
  width: 280px;
  height: 220px;
  background: rgb(209 170 103 / 45%);
  top: -30px;
  left: -30px;
  filter: blur(100px);
  border-radius: 50%;
  z-index: 0;
}

.fin-inst-usecases-section::after {
  position: absolute;
  content: "";
  width: 280px;
  height: 220px;
  background: rgb(209 170 103 / 45%);
  top: -30px;
  right: -30px;
  filter: blur(100px);
  border-radius: 50%;
  z-index: 0;
}

.fin-inst-usecases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.fin-inst-usecase-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgb(209 170 103 / 20%);
  border-radius: 22px;
  padding: 26px;
  display: flex;
  flex-direction: column;
  transition: all 0.35s ease;
}

body.light_theme .fin-inst-usecase-card {
  background: rgb(0 0 0 / 5%);
  border: 1px solid rgb(209 170 103 / 20%);
}

.fin-inst-usecase-card:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(209, 170, 103, 0.35);
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35), 0 0 24px rgba(209, 170, 103, 0.08);
}

body.light_theme .fin-inst-usecase-card:hover {
  background: #ffffff;
  border-color: #D1AA67;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.fin-inst-usecase-icon-box {
  width: 100%;
  min-height: 360px;
  border-radius: 16px;
  position: relative;
  background: rgb(255 255 255 / 10%);
  border: 1px solid rgb(209 170 103 / 20%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
}


img.blur-icon-bg {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.fin-inst-usecase-icon {
  width: 100%;
  height: 280px;
  object-fit: contain;
}

body.light_theme .fin-inst-usecase-icon-box {
  background: rgb(173 173 173 / 10%);
}

body.light_theme .fin-inst-usecase-link {
  color: #000000;
}

.fin-inst-usecase-title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 14px;
}

body.light_theme .fin-inst-usecase-title {
  color: #0f172a;
}

.fin-inst-usecase-desc {
  font-size: 18px;
  line-height: 1.65;
  color: #95959D;
  margin-bottom: 20px;
  flex-grow: 1;
}

body.light_theme .fin-inst-usecase-desc {
  color: #64748b;
}

.finbtn_card {
  display: flex;
}

.fin-inst-usecase-link {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #D1AA67;
  color: #fff;
  border-radius: 50px;
  font-size: 18px;
  padding: 14px 32px;
  font-weight: 600;
  text-decoration: none;
  transition: gap 0.2s ease, color 0.2s ease;
}

.fin-inst-usecase-link:hover {
  color: #deb776;
  gap: 12px;
}

body.light_theme .crypto-story-image::before {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 190px;
  height: 190px;
  border-radius: 100px;
  background: rgb(209 170 103 / 60%);
  filter: blur(52px);
  content: "";
  z-index: 0;
}

/* ==========================================================================
   7. CTA BANNER SECTION
   ========================================================================== */
.fin-inst-cta-section {
  position: relative;
  padding: 30px 0 100px;
}

body.light_theme .fin-inst-custody-img {
  filter: none;
}

body.light_theme .fin-inst-markets-img {
  filter: none;
}

.fin-inst-cta-card {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 28px;
  padding: 80px 40px;
  text-align: center;
  border: 1px solid rgba(209, 170, 103, 0.25);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

body.light_theme .fin-inst-cta-card {
  background-color: #ececec;
  background-image: none;
  border: 1px solid #e2e8f0;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.08);
}

.fin-inst-cta-title {
  font-size: 60px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 16px;
}

body.light_theme .fin-inst-cta-title {
  color: #0f172a;
}

.fin-inst-cta-subtitle {
  font-size: 24px;
  line-height: 1.6;
  color: #c7c7c7;
  /* max-width: 680px; */
  margin: 0 auto 36px;
}

body.light_theme .fin-inst-cta-subtitle {
  color: #475569;
}

.fin-inst-cta-actions a {
  font-size: 20px;
  padding: 15px 48px;
  font-weight: 600;
  border-radius: 50px;
}

.fin-inst-cta-actions .fin-inst-btn-secondary {
  background: #737373;
  color: #f6f6f6;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.fin-inst-cta-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 28px;
  flex-wrap: wrap;
}

.fin-inst-cta-disclaimer {
  font-size: 24px;
  line-height: 1.6;
  color: #c7c7c7;
  margin: 0;
}

body.light_theme .fin-inst-cta-disclaimer {
  color: #64748b;
}

/* ==========================================================================
   RESPONSIVE STYLES
   ========================================================================== */


@media (max-width: 1550px) {

  .fin-inst-hero-title {
    font-size: 64px;
  }

  .fin-inst-hero-decor-4 {
    right: 30%;
    bottom: 16%;
  }

  .fin-inst-section-title {
    font-size: 52px;
  }

  .fin-inst-custody-title {
    font-size: 52px;
  }

  .fin-inst-custody-desc {
    font-size: 21px;
  }

  .fin-inst-markets-title {
    font-size: 52px;
  }

  .fin-inst-markets-desc {
    font-size: 21px;
  }

  .story-num {
    font-size: 72px;
  }

  .story-title {
    font-size: 32px;
  }

  .fin-inst-cta-title {
    font-size: 52px;
  }

  .fin-inst-container {
    max-width: 95%;
  }

  .fin-inst-hero-section {
    min-height: 800px;
  }

}

@media (max-width: 1376px) {

  .fin-inst-hero-section {
    min-height: 650px;
  }

  .fin-inst-hero-title {
    font-size: 48px;
  }

  .fin-inst-hero-subtitle {
    font-size: 18px;
  }

  .fin-inst-hero-actions a {
    font-size: 16px;
    padding: 10px 32px;
    min-height: 48px;
  }

  .fin-inst-section-title {
    font-size: 40px;
  }


  .fin-inst-custody-title {
    font-size: 40px;
  }

  .fin-inst-custody-desc {
    font-size: 18px;
  }

  .fin-inst-markets-title {
    font-size: 40px;
  }

  .fin-inst-features-section p.subtext {
    font-size: 18px;
  }

  .fin-inst-markets-desc {
    font-size: 18px;
  }

  .fin-inst-cta-title {
    font-size: 40px;
  }

  .fin-inst-cta-subtitle {
    font-size: 18px;
  }

  .fin-inst-cta-disclaimer {
    font-size: 18px;
  }

}


@media (max-width: 1200px) {

  .fin-inst-hero-section {
    min-height: 500px;
  }

  .fin-inst-hero-title {
    font-size: 40px;
  }

  .fin-inst-hero-decor-4 {
    right: 20%;
    bottom: 6%;
  }

  .herovector {
    width: 42px;
  }

  .fin-inst-features-section {
    padding: 60px 0 60px;
  }

  .fin-inst-section-title {
    font-size: 32px;
  }

  .fin-inst-features-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .crypto-story {
    padding: 70px 0 80px;
  }

  .story-num {
    font-size: 56px;
  }

  .story-title {
    font-size: 26px;
  }

  .story-desc {
    font-size: 17px;
  }

  .fin-inst-usecases-section {
    padding: 60px 0;
  }

  .fin-inst-usecase-title {
    font-size: 18px;
  }

  .fin-inst-usecase-desc {
    font-size: 15px;
  }

  .fin-inst-usecase-link {
    font-size: 14px;
    padding: 10px 20px;
  }

  .fin-inst-cta-title {
    font-size: 32px;
  }

  .fin-inst-cta-actions a {
    font-size: 15px;
    padding: 11px 36px;
  }

  .fin-inst-usecase-icon {
    height: 160px;
  }

  .fin-inst-usecase-icon-box {
    min-height: auto;
    padding: 12px;
  }

}

@media (max-width: 992px) {

  .fin-inst-hero-badge span {
    font-size: 13px;
  }

  .fin-inst-hero-badge {
    padding: 7px 18px;
  }

  .fin-inst-custody-grid,
  .fin-inst-markets-grid {
    grid-template-columns: 1fr 1fr;
    gap: 26px;
  }

  .crypto-story {
    padding: 40px 20px;
  }

  .fin-inst-markets-section {
    padding: 60px 0;
  }

  .crypto-story-visual-column {
    display: none !important;
  }

  .crypto-story-grid {
    display: block;
    max-width: 100%;
    padding: 0;
  }

  .crypto-story-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-top: 36px;
  }

  .story-item {
    min-height: auto;
    padding: 24px 20px 0;
    margin-bottom: 0;
    opacity: 1 !important;
    transform: none !important;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(209, 170, 103, 0.2);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    cursor: default;
    transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  }

  .story-item:hover {
    opacity: 1 !important;
    transform: translateY(-4px) !important;
    border-color: rgba(209, 170, 103, 0.4);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
  }

  body.light_theme .story-item {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  }

  body.light_theme .story-item:hover {
    border-color: #D1AA67;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  }

  .story-item-content {
    display: flex;
    flex-direction: column;
  }

  .story-num {
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
    margin-bottom: 8px;
  }

  .story-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
    line-height: 1.3;
  }

  .story-desc {
    font-size: 14px;
    line-height: 1.6;
    color: #95959D;
    max-width: 100%;
  }

  body.light_theme .story-desc {
    color: #64748b;
  }

  .story-card-mobile-visual {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 16px;
  }

  .story-card-mobile-img-box {
    width: 100%;
    border-radius: 16px 16px 0 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-bottom: none;
    padding: 18px 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  body.light_theme .story-card-mobile-img-box {
    background: #f1f5f9;
    background-image: none;
    border-color: #e2e8f0;
  }

  .story-card-mobile-img {
    width: 100%;
    max-width: 280px;
    height: 190px;
    object-fit: contain;
    display: block;
  }

  .story-card-mobile-visual-1 .story-card-mobile-img-box,
  .story-card-mobile-visual-5 .story-card-mobile-img-box {
    justify-content: flex-end;
  }

  .fin-inst-hero-section {
    padding: 70px 0 70px;
    min-height: auto;
  }

  .fin-inst-features-section {
    padding: 40px 0 40px;
  }

  .fin-inst-custody-section {
    padding: 40px 0;
  }

  .fin-inst-custody-desc {
    font-size: 16px;
  }

}

@media (max-width: 768px) {


  .fin-inst-hero-title {
    font-size: 32px;
  }

  .fin-inst-hero-subtitle {
    font-size: 15px;
  }

  .fin-inst-section-title,
  .fin-inst-custody-title,
  .fin-inst-markets-title,
  .fin-inst-cta-title {
    font-size: 28px;
  }

  .fin-inst-features-grid {
    grid-template-columns: 1fr 1fr;
  }

  .fin-inst-section-header {
    margin-bottom: 40px;
  }

  .fin-inst-cta-card {
    padding: 50px 20px;
  }
}


@media (max-width: 767px) {

  .fin-inst-hero-section {
    padding: 35px 0 30px;
  }

  .fin-inst-hero-title {
    font-size: 24px;
    margin-bottom: 15px;
  }

  .fin-inst-hero-subtitle {
    margin-bottom: 20px;
  }

  .fin-inst-hero-actions {
    gap: 12px;
    flex-wrap: nowrap;
  }

  .fin-inst-hero-actions a {
    font-size: 14px;
    padding: 9px 20px;
    min-height: 42px;
  }

  .herovector {
    width: 22px;
    min-width: 22px;
  }

  .fin-inst-hero-decor-1 {
    top: 8%;
    left: 6%;
  }

  .fin-inst-hero-decor-2 {
    top: 16%;
    right: 10%;
  }

  .fin-inst-hero-decor-3 {
    bottom: 0%;
    left: 10%;
  }

  .fin-inst-hero-decor-4 {
    right: 5%;
    bottom: 24%;
  }

  .fin-inst-section-title,
  .fin-inst-custody-title,
  .fin-inst-markets-title,
  .fin-inst-cta-title {
    font-size: 22px;
    margin-bottom: 12px;
  }

  h2 br {
    display: none;
  }

  .fin-inst-features-section p.subtext {
    font-size: 15px;
  }

  .fin-inst-features-grid {
    gap: 32px;
  }

  .fin-inst-feature-icon-box {
    width: 48px;
    height: 48px;
    min-width: 48px;
    padding: 5px;
  }

  .fin-inst-markets-grid {
    flex-direction: column-reverse;
    display: flex;
  }

  .fin-inst-markets-text-col {
    width: 100%;
  }

  .fin-inst-markets-desc {
    font-size: 14px;
  }

  .fin-inst-markets-stats-strip {
    flex-wrap: wrap;
    gap: 12px;
  }

  .fin-inst-stat-title {
    font-size: 15px;
  }

  .fin-inst-markets-img {
    max-width: 270px;
  }

  .fin-inst-custody-img {
    max-width: 270px;
  }

  .fin-inst-usecases-grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .fin-inst-usecases-section {
    padding: 35px 0;
  }

  .fin-inst-usecases-section::before {
    width: 130px;
    height: 120px;
  }

  .fin-inst-usecase-desc {
    font-size: 14px;
  }

  .fin-inst-usecase-title {
    font-size: 17px;
    margin-bottom: 7px;
  }

  .fin-inst-usecase-link {
    font-size: 13px;
    padding: 8px 20px;
  }

  .fin-inst-container {
    max-width: 100%;
  }

  .fin-inst-cta-card {
    padding: 30px 20px;
  }

  .fin-inst-cta-section {
    padding: 30px 0 40px;
  }

  .fin-inst-feature-icon {
    width: 28px;
  }

  .fin-inst-feature-title {
    font-size: 16px;
    margin-bottom: 5px;
  }

  .fin-inst-feature-desc {
    font-size: 13px;
  }

  .fin-inst-feature-num {
    font-size: 20px;
  }

  .fin-inst-feature-after {
    top: 23px;
    left: 40px;
  }

  .fin-inst-section-header {
    margin-bottom: 24px;
  }

  .fin-inst-custody-grid,
  .fin-inst-markets-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .fin-inst-custody-section {
    padding: 35px 0;
  }

  .fin-inst-custody-desc {
    font-size: 14px;
  }

  .crypto-story {
    padding: 35px 20px 35px;
  }

  .crypto-story-content {
    grid-template-columns: 1fr;
    gap: 18px;
    margin-top: 20px;
  }

  .story-item {
    padding: 20px;
    border-radius: 18px;
  }

  .story-num {
    font-size: 32px;
    margin-bottom: 6px;
  }

  .story-title {
    font-size: 18px;
    margin-bottom: 6px;
  }

  .story-desc {
    font-size: 13px;
    line-height: 1.5;
  }

  .story-card-mobile-visual {
    margin-top: 12px;
  }

  .story-card-mobile-img-box {
    padding: 14px 8px 0;
    border-radius: 16px;
  }

  .story-card-mobile-img {
    height: 175px;
    max-width: 240px;
  }

  .fin-inst-cta-disclaimer {
    font-size: 15px;
  }

  .fin-inst-cta-subtitle {
    font-size: 15px;
    margin-bottom: 20px;
  }

  .fin-inst-cta-actions {
    margin-bottom: 18px;
  }

  .fin-inst-usecase-card {
    padding: 20px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FinancialInstitution/financialInstitution.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yDAAwG;EACxG,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAA8G;AAChH;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2CAA2C;;AAE7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,wDAAwD;EACxD,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0EAA0E;EAC1E,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qEAAqE;EACrE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yDAAiG;EACjG,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,yDAAuG;AACzG;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;EAClD,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4EAA4E;EAC5E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EAEE,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,yDAA4F;EAC5F,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,qEAAqE;EACrE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;EAC3B,+EAA+E;AACjF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yDAAmG;EACnG,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;;;AAG/E;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,0BAA0B;IAC1B,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,6EAA6E;EAC/E;;EAEA;IACE,qBAAqB;IACrB,sCAAsC;IACtC,sCAAsC;IACtC,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;EAC5C;;EAEA;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,yDAA4F;IAC5F,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;;EAGE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;;EAEE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;;;;IAIE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;AAEF","sourcesContent":["/* ==========================================================================\n   FINANCIAL INSTITUTION PAGE STYLES\n   ========================================================================== */\n\n.fin-inst-page-wrapper {\n  background-color: #171a20;\n  color: #f1f5f9;\n  position: relative;\n  min-height: 100vh;\n  font-family: inherit;\n}\n\nbody.light_theme .fin-inst-page-wrapper {\n  background-color: #fff;\n  color: #0f172a;\n}\n\n/* Light / Dark Image Switching */\n.fin-inst-page-wrapper img.light_img {\n  display: block;\n}\n\n.fin-inst-page-wrapper img.dark_img {\n  display: none;\n}\n\nbody.light_theme .fin-inst-page-wrapper img.light_img {\n  display: none !important;\n}\n\nbody.light_theme .fin-inst-page-wrapper img.dark_img {\n  display: block !important;\n}\n\n.fin-inst-container {\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 0 20px;\n  position: relative;\n  z-index: 2;\n}\n\n.fin-inst-text-gold {\n  color: #D1AA67;\n}\n\n.fin-inst-features-section p.subtext {\n  font-size: 24px;\n  color: #9CA3AF;\n  padding-top: 18px;\n}\n\n/* ==========================================================================\n   1. HERO SECTION\n   ========================================================================== */\n\n.herovector {\n  width: 58px;\n}\n\n.fin-inst-hero-section {\n  position: relative;\n  min-height: 1018px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  overflow: hidden;\n  padding: 0px 0 0px;\n  background-image: url('../../../../public/images/financial-institution-img/financial_institutionbg.jpg');\n  background-position: center top;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\nbody.light_theme .fin-inst-hero-section {\n  background-image: url('../../../../public/images/financial-institution-img/financial_institutionbg_light.jpg');\n}\n\n/* Ambient Floating Background Vectors */\n.fin-inst-hero-decor-1 {\n  position: absolute;\n  top: 19%;\n  left: 17%;\n  opacity: 1;\n  pointer-events: none;\n  animation: finFloatSlow 7s ease-in-out infinite alternate;\n}\n\n.fin-inst-hero-decor-2 {\n  position: absolute;\n  top: 34%;\n  right: 15%;\n  /* opacity: 0.6; */\n  pointer-events: none;\n  animation: finFloatSlow 8s ease-in-out infinite alternate-reverse;\n}\n\n.fin-inst-hero-decor-3 {\n  position: absolute;\n  bottom: 19%;\n  left: 25%;\n  /* opacity: 0.5; */\n  pointer-events: none;\n  animation: finFloatSlow 6s ease-in-out infinite alternate;\n}\n\n.fin-inst-hero-decor-4 {\n  position: absolute;\n  bottom: 22%;\n  right: 28%;\n  /* opacity: 0.5; */\n  pointer-events: none;\n  animation: finFloatSlow 9s ease-in-out infinite alternate-reverse;\n}\n\n@keyframes finFloatSlow {\n  0% {\n    transform: translateY(0px) rotate(0deg);\n  }\n\n  100% {\n    transform: translateY(-15px) rotate(3deg);\n  }\n}\n\n.ctaouterbl {\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.fin-inst-hero-content {\n  position: relative;\n  z-index: 3;\n  max-width: 1080px;\n  margin: 0 auto;\n}\n\n.fin-inst-hero-badge {\n  display: inline-block;\n  padding: 10px 24px;\n  border-radius: 9999px;\n  background: #24262B;\n  border: 1px solid rgb(80 80 80 / 35%);\n  margin-bottom: 18px;\n}\n\n.fin-inst-hero-badge span {\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  background: linear-gradient(91deg, #949494, #ffffff, #949494);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n}\n\n.fin-inst-hero-title {\n  font-size: 80px;\n  font-weight: 700;\n  line-height: 1.16;\n  margin-bottom: 24px;\n  background: linear-gradient(91deg, #949494, #ffffff, #949494);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n}\n\nbody.light_theme .fin-inst-hero-title {\n  background: linear-gradient(91deg, #949494, #000000, #949494);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n}\n\n.fin-inst-hero-subtitle {\n  font-size: 24px;\n  line-height: 1.6;\n  color: #9CA3AF;\n  max-width: 970px;\n  margin: 0 auto 40px;\n  font-weight: 400;\n}\n\nbody.light_theme .fin-inst-hero-subtitle {\n  color: #475569;\n}\n\n.fin-inst-hero-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  flex-wrap: wrap;\n}\n\n.fin-inst-hero-actions a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 20px;\n  font-weight: 600;\n  padding: 15px 36px;\n  min-height: 56px;\n  cursor: pointer;\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n  border-radius: 9999px;\n}\n\nbody.light_theme .fin-inst-hero-badge {\n  background: rgb(153 153 153 / 10%);\n  border: 1px solid rgb(80 80 80 / 10%);\n}\n\nbody.light_theme .fin-inst-hero-badge span {\n  background: linear-gradient(91deg, #949494, #000000, #949494);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n}\n\n/* Primary and Secondary Buttons */\n.fin-inst-btn-primary {\n  background: #D1AA67;\n  color: #0b0e14;\n  text-decoration: none;\n  border: none;\n  box-shadow: inset 0px 0px 0px 4px rgb(214 183 130);\n}\n\n.fin-inst-btn-primary:hover {\n  background: #deb776;\n  color: #000;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 28px rgba(209, 170, 103, 0.5);\n}\n\n.fin-inst-btn-secondary {\n  background: #414141;\n  color: #e2e8f0;\n  text-decoration: none;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n\n}\n\nbody.light_theme .fin-inst-btn-secondary {\n  background: #414141;\n  color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.fin-inst-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.16);\n  color: #ffffff;\n  border-color: rgba(209, 170, 103, 0.4);\n  transform: translateY(-2px);\n}\n\nbody.light_theme .fin-inst-btn-secondary:hover {\n  background: rgba(0, 0, 0, 0.1);\n  color: #0f172a;\n}\n\nbody.light_theme .fin-inst-features-section::before {\n  background: #ffffff;\n}\n\n/* Section Header Utility */\n.fin-inst-section-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.fin-inst-section-title {\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 1.10;\n  color: #ffffff;\n  margin: 0;\n}\n\nbody.light_theme .fin-inst-section-title {\n  color: #0f172a;\n}\n\n/* ==========================================================================\n   2. EVERYTHING AN EXCHANGE SHOULD BE (10 FEATURES GRID)\n   ========================================================================== */\n.fin-inst-features-section {\n  position: relative;\n  padding: 100px 0 110px;\n}\n\nbody.light_theme .fin-inst-features-section {\n  background-color: #ffffff;\n  background-image: none;\n}\n\n.fin-inst-features-section::before {\n  position: absolute;\n  content: \"\";\n  width: 50%;\n  height: 300px;\n  background: #6C604C;\n  top: 50px;\n  filter: blur(100px);\n  left: 24%;\n  border-radius: 100%;\n  z-index: 0;\n}\n\n.fin-inst-features-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 60px;\n}\n\nbody.light_theme .fin-inst-feature-icon-box {\n  background: linear-gradient(140deg, #ECDDC3 0%, #EEEBE7);\n  border: 1px solid rgb(54 51 47 / 16%);\n}\n\nbody.light_theme .fin-inst-feature-icon-box img {\n  filter: invert(1);\n}\n\n.fin-inst-feature-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.35s ease;\n  position: relative;\n}\n\n.fin-inst-feature-after {\n  position: absolute;\n  top: 43px;\n  left: 64px;\n  z-index: 333;\n}\n\n\n.fin-inst-feature-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  position: relative;\n  z-index: 999;\n}\n\n.fin-inst-feature-icon-box {\n  width: 88px;\n  height: 88px;\n  min-width: 88px;\n  border-radius: 50px;\n  background: linear-gradient(140deg, rgb(111 95 69) 0%, rgb(19 18 17) 100%);\n  border: 1px solid rgb(54 51 47);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fin-inst-feature-icon {\n  width: 42px;\n  object-fit: contain;\n}\n\n.fin-inst-feature-num {\n  font-size: 24px;\n  font-weight: 700;\n  background: linear-gradient(180deg, #b08d53 0%, rgb(0 0 0 / 0%) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n}\n\n.fin-inst-feature-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 10px;\n  line-height: 1.35;\n}\n\nbody.light_theme .fin-inst-feature-title {\n  color: #0f172a;\n}\n\n.fin-inst-feature-desc {\n  font-size: 14px;\n  line-height: 1.55;\n  color: #95959D;\n  margin: 0;\n}\n\nbody.light_theme .fin-inst-feature-desc {\n  color: #64748b;\n}\n\n/* ==========================================================================\n   3. THE MOST IMPORTANT FEATURE (MPC & CUSTODY)\n   ========================================================================== */\n.fin-inst-custody-section {\n  position: relative;\n  padding: 110px 0;\n  background-color: #0b0e14;\n  overflow: hidden;\n}\n\n.fin-inst-custody-section::before {\n  position: absolute;\n  content: \"\";\n  width: 300px;\n  height: 300px;\n  background: #6C604C;\n  opacity: 0.9;\n  top: 0px;\n  filter: blur(90px);\n  left: 0%;\n  border-radius: 100%;\n  z-index: 0;\n}\n\nbody.light_theme .fin-inst-custody-section {\n  background-color: #ffffff;\n}\n\nbody.light_theme .fin-inst-custody-section::before {\n  background: rgb(209 170 103 / 60%);\n  left: -50px;\n}\n\n.fin-inst-custody-grid {\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr;\n  gap: 60px;\n  align-items: center;\n}\n\n.fin-inst-custody-title {\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 1.22;\n  color: #ffffff;\n  margin-bottom: 20px;\n}\n\nbody.light_theme .fin-inst-custody-title {\n  color: #0f172a;\n}\n\n.fin-inst-custody-desc {\n  font-size: 24px;\n  line-height: 1.7;\n  color: #9CA3AF;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .fin-inst-custody-desc {\n  color: #475569;\n}\n\n.fin-inst-custody-img-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fin-inst-custody-img {\n  width: 100%;\n  max-width: 520px;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 16px 36px rgba(0, 0, 0, 0.4));\n}\n\n/* ==========================================================================\n   4. NEW TO CRYPTO. NOT TO MARKETS.\n   ========================================================================== */\n.fin-inst-markets-section {\n  position: relative;\n  padding: 100px 0;\n  background-image: url('../../../../public/images/financial-institution-img/market_sectionbg.jpg');\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\nbody.light_theme .fin-inst-markets-section {\n  background-image: url('../../../../public/images/financial-institution-img/market_sectionbg_light.jpg');\n}\n\n.fin-inst-markets-grid {\n  display: grid;\n  grid-template-columns: 0.85fr 1.15fr;\n  gap: 32px;\n  align-items: center;\n}\n\n.fin-inst-markets-img-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fin-inst-markets-img {\n  width: 100%;\n  max-width: 520px;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 16px 36px rgba(0, 0, 0, 0.5));\n}\n\n.fin-inst-markets-title {\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 1.1;\n  color: #ffffff;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .fin-inst-markets-title {\n  color: #0f172a;\n}\n\n.fin-inst-markets-desc {\n  font-size: 24px;\n  line-height: 1.5;\n  color: #9CA3AF;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .fin-inst-markets-desc {\n  color: #475569;\n}\n\n.fin-inst-markets-stats-strip {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 0px;\n  padding-top: 6px;\n}\n\n.fin-inst-market-stat-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-right: 1px solid rgb(209 170 103 / 12%);\n  padding-right: 16px;\n}\n\n.fin-inst-stat-icon-box {\n  width: 45px;\n  height: 45px;\n  min-width: 45px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.09);\n  border: 1px solid rgb(209 170 103 / 12%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n}\n\n.fin-inst-market-stat-item:last-child {\n  border: none;\n  padding-right: 0px;\n}\n\nbody.light_theme .fin-inst-stat-icon-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.fin-inst-stat-icon {\n  width: 24px;\n  /* height: 32px; */\n  object-fit: contain;\n}\n\n.fin-inst-stat-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.fin-inst-stat-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 3px;\n  line-height: 1.25;\n}\n\nbody.light_theme .fin-inst-stat-title {\n  color: #0f172a;\n}\n\n.fin-inst-stat-sub {\n  font-size: 12px;\n  color: #9CA3AF;\n  margin: 0;\n  line-height: 1.4;\n}\n\nbody.light_theme .fin-inst-stat-sub {\n  color: #64748b;\n}\n\n/* ==========================================================================\n   5. ONE REGULATED VENUE FOR EVERYTHING (SCROLL-DRIVEN STORYTELLING)\n   ========================================================================== */\n.crypto-story {\n  position: relative;\n  padding: 130px 0 120px;\n  background-color: #171A20;\n  overflow: hidden;\n}\n\n.crypto-story::before {\n  position: absolute;\n  content: \"\";\n  width: 55%;\n  height: 90px;\n  background: rgb(209 170 103 / 70%);\n  top: -60px;\n  left: 24%;\n  filter: blur(100px);\n  border-radius: 50%;\n  z-index: 0;\n}\n\nbody.light_theme .crypto-story {\n  background-color: #fff;\n}\n\n.crypto-story-heading {\n  text-align: center;\n  margin-bottom: 0px;\n}\n\n.crypto-story-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n  column-gap: 80px;\n  align-items: stretch;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.crypto-story-content {\n  position: relative;\n  min-width: 0;\n}\n\n.story-item {\n  min-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 40px 0;\n  transition: opacity 0.4s ease, transform 0.4s ease;\n  user-select: none;\n  cursor: pointer;\n}\n\n.story-item.is-active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.story-item.is-inactive {\n  opacity: 0.25;\n  transform: translateY(0);\n}\n\n.story-item:hover {\n  opacity: 0.7;\n}\n\n.story-item.is-active:hover {\n  opacity: 1;\n}\n\n.story-num {\n  font-size: 92px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -2px;\n  background: linear-gradient(180deg, #ffffff 0%, #0f0f0f 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n  display: inline-block;\n  margin-bottom: 10px;\n}\n\nbody.light_theme .story-num {\n  background: linear-gradient(180deg, rgb(153 153 153 / 40%) 0%, #ffffff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.story-title {\n  font-size: 36px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 16px 0;\n  line-height: 1.2;\n}\n\nbody.light_theme .story-title {\n  color: #0f172a;\n}\n\n.story-desc {\n  font-size: 20px;\n  line-height: 1.6;\n  color: #7b7b7b;\n  margin: 0;\n  max-width: 480px;\n}\n\nbody.light_theme .story-desc {\n  color: #475569;\n}\n\n.story-card-mobile-visual {\n  display: none;\n}\n\n.crypto-story-visual-column {\n  position: relative;\n  height: 100%;\n  min-width: 0;\n}\n\n.crypto-story-sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 100px;\n  height: calc(100vh - 160px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.crypto-story-image {\n  position: relative;\n  width: 100%;\n  max-width: 560px;\n  margin: 0 auto;\n  padding: 20px 0px 0px;\n  border-radius: 36px;\n  overflow: hidden;\n  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background-image: url('../../../../public/images/financial-institution-img/back_img_bg.png');\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .crypto-story-image {\n  box-shadow: 0 20px 50px rgb(0 0 0 / 7%);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #ffffff;\n}\n\n.story-img-active {\n  max-width: 560px;\n  height: 440px;\n  object-fit: contain;\n  display: block;\n  opacity: 1;\n  animation: storyImageFade 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n  will-change: opacity, transform;\n}\n\n@keyframes storyImageFade {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.crypto-story-image.crypto-story-image-5 {\n  justify-content: end;\n}\n\n.crypto-story-image.crypto-story-image-1 {\n  justify-content: end;\n}\n\n/* ==========================================================================\n   6. BUILT FOR HOW YOU USE CRYPTO (3 CARDS)\n   ========================================================================== */\n.fin-inst-usecases-section {\n  position: relative;\n  padding: 110px 0;\n  overflow: hidden;\n}\n\n.fin-inst-usecases-section::before {\n  position: absolute;\n  content: \"\";\n  width: 280px;\n  height: 220px;\n  background: rgb(209 170 103 / 45%);\n  top: -30px;\n  left: -30px;\n  filter: blur(100px);\n  border-radius: 50%;\n  z-index: 0;\n}\n\n.fin-inst-usecases-section::after {\n  position: absolute;\n  content: \"\";\n  width: 280px;\n  height: 220px;\n  background: rgb(209 170 103 / 45%);\n  top: -30px;\n  right: -30px;\n  filter: blur(100px);\n  border-radius: 50%;\n  z-index: 0;\n}\n\n.fin-inst-usecases-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n}\n\n.fin-inst-usecase-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgb(209 170 103 / 20%);\n  border-radius: 22px;\n  padding: 26px;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.35s ease;\n}\n\nbody.light_theme .fin-inst-usecase-card {\n  background: rgb(0 0 0 / 5%);\n  border: 1px solid rgb(209 170 103 / 20%);\n}\n\n.fin-inst-usecase-card:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(209, 170, 103, 0.35);\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35), 0 0 24px rgba(209, 170, 103, 0.08);\n}\n\nbody.light_theme .fin-inst-usecase-card:hover {\n  background: #ffffff;\n  border-color: #D1AA67;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n}\n\n.fin-inst-usecase-icon-box {\n  width: 100%;\n  min-height: 360px;\n  border-radius: 16px;\n  position: relative;\n  background: rgb(255 255 255 / 10%);\n  border: 1px solid rgb(209 170 103 / 20%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 28px;\n}\n\n\nimg.blur-icon-bg {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.fin-inst-usecase-icon {\n  width: 100%;\n  height: 280px;\n  object-fit: contain;\n}\n\nbody.light_theme .fin-inst-usecase-icon-box {\n  background: rgb(173 173 173 / 10%);\n}\n\nbody.light_theme .fin-inst-usecase-link {\n  color: #000000;\n}\n\n.fin-inst-usecase-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 14px;\n}\n\nbody.light_theme .fin-inst-usecase-title {\n  color: #0f172a;\n}\n\n.fin-inst-usecase-desc {\n  font-size: 18px;\n  line-height: 1.65;\n  color: #95959D;\n  margin-bottom: 20px;\n  flex-grow: 1;\n}\n\nbody.light_theme .fin-inst-usecase-desc {\n  color: #64748b;\n}\n\n.finbtn_card {\n  display: flex;\n}\n\n.fin-inst-usecase-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #D1AA67;\n  color: #fff;\n  border-radius: 50px;\n  font-size: 18px;\n  padding: 14px 32px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: gap 0.2s ease, color 0.2s ease;\n}\n\n.fin-inst-usecase-link:hover {\n  color: #deb776;\n  gap: 12px;\n}\n\nbody.light_theme .crypto-story-image::before {\n  position: absolute;\n  left: 0px;\n  bottom: 0px;\n  width: 190px;\n  height: 190px;\n  border-radius: 100px;\n  background: rgb(209 170 103 / 60%);\n  filter: blur(52px);\n  content: \"\";\n  z-index: 0;\n}\n\n/* ==========================================================================\n   7. CTA BANNER SECTION\n   ========================================================================== */\n.fin-inst-cta-section {\n  position: relative;\n  padding: 30px 0 100px;\n}\n\nbody.light_theme .fin-inst-custody-img {\n  filter: none;\n}\n\nbody.light_theme .fin-inst-markets-img {\n  filter: none;\n}\n\n.fin-inst-cta-card {\n  position: relative;\n  background-image: url('../../../../public/images/financial-institution-img/trade_exchange_cta.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 28px;\n  padding: 80px 40px;\n  text-align: center;\n  border: 1px solid rgba(209, 170, 103, 0.25);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\nbody.light_theme .fin-inst-cta-card {\n  background-color: #ececec;\n  background-image: none;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.08);\n}\n\n.fin-inst-cta-title {\n  font-size: 60px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 16px;\n}\n\nbody.light_theme .fin-inst-cta-title {\n  color: #0f172a;\n}\n\n.fin-inst-cta-subtitle {\n  font-size: 24px;\n  line-height: 1.6;\n  color: #c7c7c7;\n  /* max-width: 680px; */\n  margin: 0 auto 36px;\n}\n\nbody.light_theme .fin-inst-cta-subtitle {\n  color: #475569;\n}\n\n.fin-inst-cta-actions a {\n  font-size: 20px;\n  padding: 15px 48px;\n  font-weight: 600;\n  border-radius: 50px;\n}\n\n.fin-inst-cta-actions .fin-inst-btn-secondary {\n  background: #737373;\n  color: #f6f6f6;\n  text-decoration: none;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.fin-inst-cta-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-bottom: 28px;\n  flex-wrap: wrap;\n}\n\n.fin-inst-cta-disclaimer {\n  font-size: 24px;\n  line-height: 1.6;\n  color: #c7c7c7;\n  margin: 0;\n}\n\nbody.light_theme .fin-inst-cta-disclaimer {\n  color: #64748b;\n}\n\n/* ==========================================================================\n   RESPONSIVE STYLES\n   ========================================================================== */\n\n\n@media (max-width: 1550px) {\n\n  .fin-inst-hero-title {\n    font-size: 64px;\n  }\n\n  .fin-inst-hero-decor-4 {\n    right: 30%;\n    bottom: 16%;\n  }\n\n  .fin-inst-section-title {\n    font-size: 52px;\n  }\n\n  .fin-inst-custody-title {\n    font-size: 52px;\n  }\n\n  .fin-inst-custody-desc {\n    font-size: 21px;\n  }\n\n  .fin-inst-markets-title {\n    font-size: 52px;\n  }\n\n  .fin-inst-markets-desc {\n    font-size: 21px;\n  }\n\n  .story-num {\n    font-size: 72px;\n  }\n\n  .story-title {\n    font-size: 32px;\n  }\n\n  .fin-inst-cta-title {\n    font-size: 52px;\n  }\n\n  .fin-inst-container {\n    max-width: 95%;\n  }\n\n  .fin-inst-hero-section {\n    min-height: 800px;\n  }\n\n}\n\n@media (max-width: 1376px) {\n\n  .fin-inst-hero-section {\n    min-height: 650px;\n  }\n\n  .fin-inst-hero-title {\n    font-size: 48px;\n  }\n\n  .fin-inst-hero-subtitle {\n    font-size: 18px;\n  }\n\n  .fin-inst-hero-actions a {\n    font-size: 16px;\n    padding: 10px 32px;\n    min-height: 48px;\n  }\n\n  .fin-inst-section-title {\n    font-size: 40px;\n  }\n\n\n  .fin-inst-custody-title {\n    font-size: 40px;\n  }\n\n  .fin-inst-custody-desc {\n    font-size: 18px;\n  }\n\n  .fin-inst-markets-title {\n    font-size: 40px;\n  }\n\n  .fin-inst-features-section p.subtext {\n    font-size: 18px;\n  }\n\n  .fin-inst-markets-desc {\n    font-size: 18px;\n  }\n\n  .fin-inst-cta-title {\n    font-size: 40px;\n  }\n\n  .fin-inst-cta-subtitle {\n    font-size: 18px;\n  }\n\n  .fin-inst-cta-disclaimer {\n    font-size: 18px;\n  }\n\n}\n\n\n@media (max-width: 1200px) {\n\n  .fin-inst-hero-section {\n    min-height: 500px;\n  }\n\n  .fin-inst-hero-title {\n    font-size: 40px;\n  }\n\n  .fin-inst-hero-decor-4 {\n    right: 20%;\n    bottom: 6%;\n  }\n\n  .herovector {\n    width: 42px;\n  }\n\n  .fin-inst-features-section {\n    padding: 60px 0 60px;\n  }\n\n  .fin-inst-section-title {\n    font-size: 32px;\n  }\n\n  .fin-inst-features-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .crypto-story {\n    padding: 70px 0 80px;\n  }\n\n  .story-num {\n    font-size: 56px;\n  }\n\n  .story-title {\n    font-size: 26px;\n  }\n\n  .story-desc {\n    font-size: 17px;\n  }\n\n  .fin-inst-usecases-section {\n    padding: 60px 0;\n  }\n\n  .fin-inst-usecase-title {\n    font-size: 18px;\n  }\n\n  .fin-inst-usecase-desc {\n    font-size: 15px;\n  }\n\n  .fin-inst-usecase-link {\n    font-size: 14px;\n    padding: 10px 20px;\n  }\n\n  .fin-inst-cta-title {\n    font-size: 32px;\n  }\n\n  .fin-inst-cta-actions a {\n    font-size: 15px;\n    padding: 11px 36px;\n  }\n\n  .fin-inst-usecase-icon {\n    height: 160px;\n  }\n\n  .fin-inst-usecase-icon-box {\n    min-height: auto;\n    padding: 12px;\n  }\n\n}\n\n@media (max-width: 992px) {\n\n  .fin-inst-hero-badge span {\n    font-size: 13px;\n  }\n\n  .fin-inst-hero-badge {\n    padding: 7px 18px;\n  }\n\n  .fin-inst-custody-grid,\n  .fin-inst-markets-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 26px;\n  }\n\n  .crypto-story {\n    padding: 40px 20px;\n  }\n\n  .fin-inst-markets-section {\n    padding: 60px 0;\n  }\n\n  .crypto-story-visual-column {\n    display: none !important;\n  }\n\n  .crypto-story-grid {\n    display: block;\n    max-width: 100%;\n    padding: 0;\n  }\n\n  .crypto-story-content {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n    margin-top: 36px;\n  }\n\n  .story-item {\n    min-height: auto;\n    padding: 24px 20px 0;\n    margin-bottom: 0;\n    opacity: 1 !important;\n    transform: none !important;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(209, 170, 103, 0.2);\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    overflow: hidden;\n    cursor: default;\n    transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\n  }\n\n  .story-item:hover {\n    opacity: 1 !important;\n    transform: translateY(-4px) !important;\n    border-color: rgba(209, 170, 103, 0.4);\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n  }\n\n  body.light_theme .story-item {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n  }\n\n  body.light_theme .story-item:hover {\n    border-color: #D1AA67;\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);\n  }\n\n  .story-item-content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .story-num {\n    font-size: 38px;\n    font-weight: 800;\n    line-height: 1;\n    margin-bottom: 8px;\n  }\n\n  .story-title {\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 8px;\n    line-height: 1.3;\n  }\n\n  .story-desc {\n    font-size: 14px;\n    line-height: 1.6;\n    color: #95959D;\n    max-width: 100%;\n  }\n\n  body.light_theme .story-desc {\n    color: #64748b;\n  }\n\n  .story-card-mobile-visual {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    margin-top: 16px;\n  }\n\n  .story-card-mobile-img-box {\n    width: 100%;\n    border-radius: 16px 16px 0 0;\n    background-image: url('../../../../public/images/financial-institution-img/back_img_bg.png');\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-bottom: none;\n    padding: 18px 10px 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n  }\n\n  body.light_theme .story-card-mobile-img-box {\n    background: #f1f5f9;\n    background-image: none;\n    border-color: #e2e8f0;\n  }\n\n  .story-card-mobile-img {\n    width: 100%;\n    max-width: 280px;\n    height: 190px;\n    object-fit: contain;\n    display: block;\n  }\n\n  .story-card-mobile-visual-1 .story-card-mobile-img-box,\n  .story-card-mobile-visual-5 .story-card-mobile-img-box {\n    justify-content: flex-end;\n  }\n\n  .fin-inst-hero-section {\n    padding: 70px 0 70px;\n    min-height: auto;\n  }\n\n  .fin-inst-features-section {\n    padding: 40px 0 40px;\n  }\n\n  .fin-inst-custody-section {\n    padding: 40px 0;\n  }\n\n  .fin-inst-custody-desc {\n    font-size: 16px;\n  }\n\n}\n\n@media (max-width: 768px) {\n\n\n  .fin-inst-hero-title {\n    font-size: 32px;\n  }\n\n  .fin-inst-hero-subtitle {\n    font-size: 15px;\n  }\n\n  .fin-inst-section-title,\n  .fin-inst-custody-title,\n  .fin-inst-markets-title,\n  .fin-inst-cta-title {\n    font-size: 28px;\n  }\n\n  .fin-inst-features-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .fin-inst-section-header {\n    margin-bottom: 40px;\n  }\n\n  .fin-inst-cta-card {\n    padding: 50px 20px;\n  }\n}\n\n\n@media (max-width: 767px) {\n\n  .fin-inst-hero-section {\n    padding: 35px 0 30px;\n  }\n\n  .fin-inst-hero-title {\n    font-size: 24px;\n    margin-bottom: 15px;\n  }\n\n  .fin-inst-hero-subtitle {\n    margin-bottom: 20px;\n  }\n\n  .fin-inst-hero-actions {\n    gap: 12px;\n    flex-wrap: nowrap;\n  }\n\n  .fin-inst-hero-actions a {\n    font-size: 14px;\n    padding: 9px 20px;\n    min-height: 42px;\n  }\n\n  .herovector {\n    width: 22px;\n    min-width: 22px;\n  }\n\n  .fin-inst-hero-decor-1 {\n    top: 8%;\n    left: 6%;\n  }\n\n  .fin-inst-hero-decor-2 {\n    top: 16%;\n    right: 10%;\n  }\n\n  .fin-inst-hero-decor-3 {\n    bottom: 0%;\n    left: 10%;\n  }\n\n  .fin-inst-hero-decor-4 {\n    right: 5%;\n    bottom: 24%;\n  }\n\n  .fin-inst-section-title,\n  .fin-inst-custody-title,\n  .fin-inst-markets-title,\n  .fin-inst-cta-title {\n    font-size: 22px;\n    margin-bottom: 12px;\n  }\n\n  h2 br {\n    display: none;\n  }\n\n  .fin-inst-features-section p.subtext {\n    font-size: 15px;\n  }\n\n  .fin-inst-features-grid {\n    gap: 32px;\n  }\n\n  .fin-inst-feature-icon-box {\n    width: 48px;\n    height: 48px;\n    min-width: 48px;\n    padding: 5px;\n  }\n\n  .fin-inst-markets-grid {\n    flex-direction: column-reverse;\n    display: flex;\n  }\n\n  .fin-inst-markets-text-col {\n    width: 100%;\n  }\n\n  .fin-inst-markets-desc {\n    font-size: 14px;\n  }\n\n  .fin-inst-markets-stats-strip {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .fin-inst-stat-title {\n    font-size: 15px;\n  }\n\n  .fin-inst-markets-img {\n    max-width: 270px;\n  }\n\n  .fin-inst-custody-img {\n    max-width: 270px;\n  }\n\n  .fin-inst-usecases-grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .fin-inst-usecases-section {\n    padding: 35px 0;\n  }\n\n  .fin-inst-usecases-section::before {\n    width: 130px;\n    height: 120px;\n  }\n\n  .fin-inst-usecase-desc {\n    font-size: 14px;\n  }\n\n  .fin-inst-usecase-title {\n    font-size: 17px;\n    margin-bottom: 7px;\n  }\n\n  .fin-inst-usecase-link {\n    font-size: 13px;\n    padding: 8px 20px;\n  }\n\n  .fin-inst-container {\n    max-width: 100%;\n  }\n\n  .fin-inst-cta-card {\n    padding: 30px 20px;\n  }\n\n  .fin-inst-cta-section {\n    padding: 30px 0 40px;\n  }\n\n  .fin-inst-feature-icon {\n    width: 28px;\n  }\n\n  .fin-inst-feature-title {\n    font-size: 16px;\n    margin-bottom: 5px;\n  }\n\n  .fin-inst-feature-desc {\n    font-size: 13px;\n  }\n\n  .fin-inst-feature-num {\n    font-size: 20px;\n  }\n\n  .fin-inst-feature-after {\n    top: 23px;\n    left: 40px;\n  }\n\n  .fin-inst-section-header {\n    margin-bottom: 24px;\n  }\n\n  .fin-inst-custody-grid,\n  .fin-inst-markets-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .fin-inst-custody-section {\n    padding: 35px 0;\n  }\n\n  .fin-inst-custody-desc {\n    font-size: 14px;\n  }\n\n  .crypto-story {\n    padding: 35px 20px 35px;\n  }\n\n  .crypto-story-content {\n    grid-template-columns: 1fr;\n    gap: 18px;\n    margin-top: 20px;\n  }\n\n  .story-item {\n    padding: 20px;\n    border-radius: 18px;\n  }\n\n  .story-num {\n    font-size: 32px;\n    margin-bottom: 6px;\n  }\n\n  .story-title {\n    font-size: 18px;\n    margin-bottom: 6px;\n  }\n\n  .story-desc {\n    font-size: 13px;\n    line-height: 1.5;\n  }\n\n  .story-card-mobile-visual {\n    margin-top: 12px;\n  }\n\n  .story-card-mobile-img-box {\n    padding: 14px 8px 0;\n    border-radius: 16px;\n  }\n\n  .story-card-mobile-img {\n    height: 175px;\n    max-width: 240px;\n  }\n\n  .fin-inst-cta-disclaimer {\n    font-size: 15px;\n  }\n\n  .fin-inst-cta-subtitle {\n    font-size: 15px;\n    margin-bottom: 20px;\n  }\n\n  .fin-inst-cta-actions {\n    margin-bottom: 18px;\n  }\n\n  .fin-inst-usecase-card {\n    padding: 20px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
